import { render, staticRenderFns } from "./OurWorkComponent2.vue?vue&type=template&id=1a37a522&scoped=true&"
import script from "./OurWorkComponent2.vue?vue&type=script&lang=js&"
export * from "./OurWorkComponent2.vue?vue&type=script&lang=js&"
import style0 from "./OurWorkComponent2.vue?vue&type=style&index=0&id=1a37a522&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a37a522",
  null
  
)

export default component.exports